import React, { useMemo } from 'react';
import { Flex, Tag, Typography } from '@banhala/ui-kit';
import { useGoodsDetail } from '../../../queries/useGoodsDetail';
import { convertToDayJs, getDayOfWeek, isNil } from 'shared/src/utils';
import { extractTagInfo } from '../utils/extractHtmlText';

export const MarketVacationInfo: React.FC = () => {
  const { data: goodsDetail } = useGoodsDetail();

  const message = useMemo(() => {
    if (isNil(goodsDetail)) return null;

    if (isNil(goodsDetail.goods.market.vacation)) {
      return null;
    }

    const restartAt = convertToDayJs(
      goodsDetail.goods.market.vacation.restart_at,
    );

    return extractTagInfo(
      `<b>${restartAt.format('M/D')}(${getDayOfWeek(restartAt)}) 이후</b> 순차 발송`,
    );
  }, [goodsDetail]);

  if (isNil(message)) return null;

  return (
    <Flex.Row alignItems={'center'} gap={8}>
      <Typography type={'body2'}>
        <Typography type={'subtitle2'}>{message.inner}</Typography>{' '}
        {message.tail}
      </Typography>
      <Tag type={'secondary'} color={'pink'} size={'xsmall'}>
        마켓 휴무
      </Tag>
    </Flex.Row>
  );
};
